/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { EmailOptionView } from './emailOptionView';

export interface SyncableView {
  job_candidate_id: string;
  full_name?: string | null;
  emails?: EmailOptionView[];
  auto_pick?: string | null;
  will_use_placeholder?: boolean;
  enrichment_available?: boolean;
  application_questions_soft_hint?: boolean;
}
